import React from 'react';
import maintenance from './maintenance.svg';
import './Banner.scss';

const UnderMaintenanceBanner = () => (
  <div className="banner">
    <div className="container">
      <div className="offer-container">
        <div className="offer-part-one">
          <h2>
            Howdy folks, we&apos;re in the
            middle of some planned maintenance.
          </h2>
          <div className="banner-item-subtitle">
            We apologise any for inconvenience,
            we should be up and running soon.
          </div>
        </div>
        <div className="offer-part-two">
          <img src={maintenance} alt={'Planned maintenance in progress'} />
        </div>
      </div>
    </div>
  </div>
);

export default UnderMaintenanceBanner;



/** WEBPACK FOOTER **
 ** ./src/components/home/Banner/UnderMaintenanceBanner.js
 **/